import 'expose?$!expose?jQuery!jquery'
import bootstrap from 'bootstrap'

import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase  from 'firebase'
import VueNotie from 'vue-notie'


import App from './App'
import Home from './components/Home'
import Registro from './components/Registro'
import Blog from './components/Blog'
import BlogHome from './components/Blog-Home'
import PostItem from './components/Post-Item'

import './assets/css/bootstrap.min.css'
import './assets/css/notie.css'
import './assets/css/quill.core.css'


Vue.use(VueRouter)
Vue.use(VueNotie)

const router = new VueRouter({
 mode:'history',
 routes: [
   { path: '/',
     component: Home,
     children: [ 
        {
            path:'/',
            component: BlogHome
        },
        {
          path: 'post/:id',
          name: 'postItem',
          component: PostItem,
        }
     ]},
     
     { path: '/registro', component: Registro },
 ],
 scrollBehavior (to, from, savedPosition) {
  return { x: 0, y: 0 }
}
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
})





// WEBPACK FOOTER //
// ./E:/dev/repos/wpo_site/src/main.js